module.exports = __webpack_public_path__ + "img/image9.a4b63cd7.svg";